import React from 'react'

interface CompProps {
  width: any
  height: any
}

const TransportIcon: React.FC<CompProps> = ({ height, width }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.30732 15.9383C3.16906 15.9383 3.02216 15.8951 2.90982 15.8C2.62466 15.5754 2.58145 15.1692 2.79748 14.8927L4.60353 13.3805C4.8282 13.104 5.19114 12.7324 5.46766 12.9484C5.74418 13.1645 6.55646 12.6633 6.33179 12.9484L3.80852 15.6877C3.68754 15.8519 3.49743 15.9383 3.30732 15.9383Z'
      fill='#BFBFBF'
    />
    <path
      d='M12.8301 15.9469C12.6399 15.9469 12.4498 15.8605 12.3202 15.6964L9.78831 12.9484C9.56363 12.6633 10.3759 13.1645 10.6525 12.9484C10.9376 12.7237 10.8685 12.6719 11.0845 12.9484L13.3226 14.9014C13.5473 15.1865 13.4954 15.5927 13.2189 15.8087C13.1066 15.9037 12.9683 15.9469 12.8301 15.9469Z'
      fill='#BFBFBF'
    />
    <path
      d='M12.398 13.9249H3.7394C2.66788 13.9249 1.7951 13.0521 1.7951 11.9806V2.38875C1.7951 1.31723 2.66788 0.444458 3.7394 0.444458H12.398C13.4695 0.444458 14.3423 1.31723 14.3423 2.38875V11.9806C14.3423 13.0521 13.4695 13.9249 12.398 13.9249ZM3.7394 1.74065C3.3851 1.74065 3.0913 2.03446 3.0913 2.38875V11.9806C3.0913 12.3349 3.3851 12.6287 3.7394 12.6287H12.398C12.7523 12.6287 13.0461 12.3349 13.0461 11.9806V2.38875C13.0461 2.03446 12.7523 1.74065 12.398 1.74065H3.7394Z'
      fill='#BFBFBF'
    />
    <path
      d='M13.6855 9.5956H2.42593C2.07164 9.5956 1.77783 9.30179 1.77783 8.9475C1.77783 8.59321 2.07164 8.2994 2.42593 8.2994H13.6855C14.0398 8.2994 14.3336 8.59321 14.3336 8.9475C14.3336 9.30179 14.0485 9.5956 13.6855 9.5956Z'
      fill='#BFBFBF'
    />
    <path
      d='M13.6855 4.52315H2.42593C2.07164 4.52315 1.77783 4.23799 1.77783 3.87505C1.77783 3.51212 2.07164 3.22696 2.42593 3.22696H13.6855C14.0398 3.22696 14.3336 3.52076 14.3336 3.87505C14.3336 4.22935 14.0485 4.52315 13.6855 4.52315Z'
      fill='#BFBFBF'
    />
    <path
      d='M5.66641 11.825C6.02912 11.825 6.32315 11.531 6.32315 11.1683C6.32315 10.8056 6.02912 10.5116 5.66641 10.5116C5.3037 10.5116 5.00967 10.8056 5.00967 11.1683C5.00967 11.531 5.3037 11.825 5.66641 11.825Z'
      fill='#BFBFBF'
    />
    <path
      d='M10.4537 11.825C10.8164 11.825 11.1104 11.531 11.1104 11.1683C11.1104 10.8056 10.8164 10.5116 10.4537 10.5116C10.091 10.5116 9.79696 10.8056 9.79696 11.1683C9.79696 11.531 10.091 11.825 10.4537 11.825Z'
      fill='#BFBFBF'
    />
  </svg>
)

export default TransportIcon
